import { render, staticRenderFns } from "./LaunchPads.vue?vue&type=template&id=71492022&scoped=true&"
import script from "./LaunchPads.vue?vue&type=script&lang=js&"
export * from "./LaunchPads.vue?vue&type=script&lang=js&"
import style0 from "./LaunchPads.vue?vue&type=style&index=0&id=71492022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71492022",
  null
  
)

export default component.exports